import {
  Badge,
  Button,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr
} from '@chakra-ui/react'
import { FC } from 'react'
import { MdCheckCircle, MdUpload } from 'react-icons/md'

import FuModalHeader from '@component/FollowUpFornecedor/ModalHeader'

export type UploadRow = {
  id: number
  statusAprovacao: 1 | 2
  nomeProduto: string
  fornecedor: string
}

interface Props {
  isOpen: boolean
  rows: UploadRow[]
  onClose: () => void
  onConfirm: () => void
}

const UploadModal: FC<Props> = ({ isOpen, rows, onClose, onConfirm }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    isCentered
    scrollBehavior="inside"
    size="lg"
  >
    <ModalOverlay />
    <ModalContent>
      <FuModalHeader
        icon={MdUpload}
        title={`${rows.length} item${rows.length !== 1 ? 's' : ''} com ação`}
      />
      <ModalCloseButton color="white" />
      <ModalBody bg="white" py={4}>
        <Table size="sm">
          <Thead bg="gray.50">
            <Tr>
              <Th>Produto</Th>
              <Th>Fornecedor</Th>
              <Th>Ação</Th>
            </Tr>
          </Thead>
          <Tbody>
            {rows.map(row => (
              <Tr key={row.id}>
                <Td fontSize="12px">{row.nomeProduto}</Td>
                <Td fontSize="12px">{row.fornecedor}</Td>
                <Td>
                  {row.statusAprovacao === 1 ? (
                    <Badge
                      bg="green.600"
                      color="white"
                      borderRadius="md"
                      px={2}
                    >
                      Aprovar
                    </Badge>
                  ) : (
                    <Badge bg="red.500" color="white" borderRadius="md" px={2}>
                      Recusar
                    </Badge>
                  )}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </ModalBody>
      <ModalFooter
        bg="white"
        borderBottomLeftRadius={5}
        borderBottomRightRadius={5}
      >
        <Button variant="ghost" mr={3} onClick={onClose}>
          Cancelar
        </Button>
        <Button
          bg="#1d5840"
          color="white"
          leftIcon={<Icon as={MdCheckCircle} />}
          _hover={{ bg: 'green.700' }}
          onClick={onConfirm}
        >
          Confirmar
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
)

export default UploadModal
